import { render, staticRenderFns } from "./ClientProtocols.vue?vue&type=template&id=14b12f7c&scoped=true"
import script from "./ClientProtocols.vue?vue&type=script&lang=js"
export * from "./ClientProtocols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b12f7c",
  null
  
)

export default component.exports